import React, { FC } from 'react';
import { IFormItemType } from '@interfaces/FormItemType';
import { CustomInput, CustomSelect, CustomFileUpload, CustomRadio } from '@ui/components/atoms';
import { Col, Row } from 'react-bootstrap';

type Props = {
  items: IFormItemType[];
  isSmallLabel?: boolean;
};

export const GeneratedForm: FC<Props> = ({ items, isSmallLabel }) => {
  return (
    <Row className="w-100 mx-0 d-flex py-3" style={{ rowGap: 25 }}>
      {items.map(({ fullWidth, isCenter, ...item }, index) => {
        let field = <CustomInput formItem={item} isSmallLabel={isSmallLabel} />;
        if (item.type === 'select') {
          const { type, ...rest } = item;
          field = <CustomSelect formItem={rest} isSmallLabel={isSmallLabel} />;
        }
        if (item.type === 'radio') {
          const { type, ...rest } = item;
          field = <CustomRadio formItem={item} />;
        }
        if (item.type === 'attachment') {
          const { type, onChange, ...rest } = item;
          field = (
            <CustomFileUpload
              onFileSelect={(file) => {
                onChange(file);
              }}
              required={item.required}
              nationality={item.nationality}
              error={item.errorFeedback}
              touched={item.isTouched}
            />
          );
        }
        return (
          <Col
            style={{ margin: isCenter ? '0 auto' : '' }}
            key={index}
            lg={fullWidth || item.type === 'textarea' ? 12 : isCenter ? 8 : 6}
            sm={12}
          >
            {field}
          </Col>
        );
      })}
    </Row>
  );
};
